// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"472.753\" height=\"474.055\" viewBox=\"-207.128 -208.055 472.753 474.055\"><path fill=\"#fff\" d=\"M-207.106-207.973h472.7v473.932h-472.7z\"/><path fill=\"#268bcc\" d=\"M265.625 266h-472.753v-474.055z\"/></svg>";
// Exports
module.exports = code;